import { Component, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SpinnerService } from '../../core/services/loading.service';
import { MenuItem, MessageService } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { Menu } from 'primeng/menu';
import { APP_CONFIG } from '../../core/app-config.token';
import { SharedModule } from '../../shared/shared.module';
import { NavigationControlService } from '../../core/services/navigation-control.service';
import { StreetService } from '../../core/services/street.service';
@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink, AvatarModule, Menu, SharedModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  cfg = inject(APP_CONFIG);
  open = signal(false);

  // Paleta simple para fondo del avatar
  avatarBg = '#6366F1';

  displayName = 'Usuario';
  initial = 'U';
  isLoggedIn = false;

  items: MenuItem[] = [];

  constructor(
    private _router: Router,
    public spinner: SpinnerService,
    private messageService: MessageService,
    private navControl: NavigationControlService,
    private streetService: StreetService,
  ) { }

  ngOnInit(): void {
    const user = this.getIdentityUser();
    this.isLoggedIn = !!user;
    let nombreRaw: string;


    if (user?.avatar && /^#([0-9A-F]{3}){1,2}$/i.test(user.avatar)) {
      this.avatarBg = user.avatar;
    }

    if (user?.nombreCompleto?.trim()) {
      nombreRaw = user.nombreCompletoSolicitante;
    } else if (user?.nombresSolicitante || user?.apePatSolicitante || user?.apeMatSolicitante) {
      nombreRaw = [
        user?.nombresSolicitante,
        user?.apePatSolicitante,
        user?.apeMatSolicitante
      ]
        .filter(Boolean)
        .join(' ');
    } else {
      nombreRaw = 'Usuario';
    }

    this.displayName = this.toTitleCase(nombreRaw);
    this.initial = this.displayName.trim() ? this.displayName.trim().charAt(0).toUpperCase() : 'U';

    this.items = [
      { label: 'Mis Servicios', icon: 'pi pi-th-large', routerLink: ['/'] },
      { label: 'Mi Perfil', icon: 'pi pi-user', routerLink: ['/perfil'] },
      { separator: true },
      { label: 'Cerrar sesión', icon: 'pi pi-sign-out', command: () => this.logout() },
    ];
  }

  private getIdentityUser(): any | null {
    const keys = ['identity.user'];
    for (const k of keys) {
      try {
        const raw = sessionStorage.getItem(k);
        if (raw) return JSON.parse(raw);
      } catch { }
    }
    return null;
  }

  private toTitleCase(s: string): string {
    // Convierte "GABRIELA MONTERREY" -> "Gabriela Monterrey"
    return String(s)
      .toLowerCase()
      .replace(/\b\p{L}+/gu, (w) => w.charAt(0).toUpperCase() + w.slice(1));
  }

  private clearSession() {
    try {
      sessionStorage.removeItem('identity.user');
      sessionStorage.removeItem('identity.token');
      this.streetService.clearCache();
    } catch { }
  }

  logout() {

    this.navControl.forceExit = true;

    this.spinner.show('Cerrando sesión...');
    this.clearSession();

    setTimeout(() => {
      this._router.navigate(['/login']);
    }, 1200);
  }
}
